export default __webpack_public_path__ + "static/media/feature2.38f56c34.jpg";